/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import './styles.scss'
import {
  Grid,
  Tooltip,
  Alert,
  Snackbar,
} from '@mui/material'

import {
  Col,
  Collapse,
  InputNumber,
  Layout,
  Row,
  Space,
  Tabs,
  TreeSelect,
  Checkbox,
  Button,
  Form,
  DatePicker,
  Alert as AntdAlert,
} from 'antd'
import CurrencyFormat from 'react-currency-format'
import InfoIcon from '@material-ui/icons/Info'

//HELPERS
import {
  formatDBDate,
  checkDateIsBetweenRange,
  addArrayItems,
  formatDateToDB,
} from '../../utils/helpers'

//API
import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import { firebaseDb } from '../../config/firebaseConfig'

import { getScheduleExperience } from '../../services/FirebaseServices/experienceServices'

import {
  checkAvailabilityHotels,
  getAllReservationsForExperience,
  getResourcesByDayAndHour,
  getServiceByDayAndHour,
} from '../../services/FirebaseServices/reservationServices'

import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectSingleDate,
  makeSelectTime,
  makeSelectTimeSelect,
  makeSelectPartialPrice,
  makeSelectAddonsPrice,
  makeSelectAddonsPersonsPrice,
  makeSelectReservationPrice,
  makeSelectSelectedAddons,
  makeSelectHotelHour,
  makeSelectSingleLimit,
  makeSelectGiftCard,
  set_start_date,
  set_end_date,
  set_guest_amount,
  set_child_amount,
  set_total_price,
  set_single_date,
  set_time,
  set_time_select,
  set_hotel_hour,
  set_partial_price,
  set_addons_price,
  set_addons_persons_price,
  set_reservation_price,
  set_selected_addons,
  set_service,
  set_single_limit,
  set_is_gift_card,
} from '../../redux/ducks/reservationDetails'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import { statePayments } from '../../utils/enums'
const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectSingleExperience,
    makeSelectGuestAmount,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectSingleDate,
    makeSelectTime,
    makeSelectAgency,
    makeSelectTimeSelect,
    makeSelectPartialPrice,
    makeSelectAddonsPrice,
    makeSelectAddonsPersonsPrice,
    makeSelectReservationPrice,
    makeSelectSelectedAddons,
    makeSelectHotelHour,
    makeSelectSingleLimit,
    makeSelectGiftCard,
  ],
  (
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    totalPrice,
    singleDate,
    time,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    hotelHour,
    singleLimit,
    giftCard,
  ) => ({
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    totalPrice,
    singleDate,
    time,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    hotelHour,
    singleLimit,
    giftCard,
  }),
)

const actionDispatch = (dispatch) => ({
  setStartDate: (startDate) => dispatch(set_start_date(startDate)),
  setEndDate: (endDate) => dispatch(set_end_date(endDate)),
  setGuestAmount: (guestAmount) => dispatch(set_guest_amount(guestAmount)),
  setChildAmount: (childAmount) => dispatch(set_child_amount(childAmount)),
  setTotalPrice: (totalPrice) => dispatch(set_total_price(totalPrice)),
  setSingleDate: (singleDate) => dispatch(set_single_date(singleDate)),
  setTime: (time) => dispatch(set_time(time)),
  setTimeSelect: (timeSelect) => dispatch(set_time_select(timeSelect)),
  setHotelHour: (hotelHour) => dispatch(set_hotel_hour(hotelHour)),
  setPartialPrice: (partialPrice) => dispatch(set_partial_price(partialPrice)),
  setAddonsPrice: (addonsPrice) => dispatch(set_addons_price(addonsPrice)),
  setAddonsPersonsPrice: (addonsPersonsPrice) =>
    dispatch(set_addons_persons_price(addonsPersonsPrice)),
  setReservationPrice: (reservationPrice) =>
    dispatch(set_reservation_price(reservationPrice)),
  setSelectedAddons: (selectedAddons) =>
    dispatch(set_selected_addons(selectedAddons)),
  setService: (service) => dispatch(set_service(service)),
  setSingleLimit: (singleLimit) => dispatch(set_single_limit(singleLimit)),
  setIsGiftCard: (giftCard) => dispatch(set_is_gift_card(giftCard)),
})

const ReservationDetailsAgency = ({ handleNext, classes, hotDeal }) => {
  const {
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    singleDate,
    time,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    giftCard,
  } = useSelector(stateSelector)
  const {
    setStartDate,
    setEndDate,
    setGuestAmount,
    setTotalPrice,
    setChildAmount,
    setSingleDate,
    setTime,
    setTimeSelect,
    setHotelHour,
    setPartialPrice,
    setAddonsPrice,
    setAddonsPersonsPrice,
    setReservationPrice,
    setSelectedAddons,
    setService,
    setIsGiftCard,
  } = actionDispatch(useDispatch())

  const [schedule, setSchedule] = useState({})
  const [isDisableTime, setIsDisableTime] = useState(time ? false : true)
  const [isErrorGuestAmount, setIsErrorGuestAmount] = useState(false)
  const [isErrorChildAmount, setIsErrorChildAmount] = useState(false)
  const [isErrorSingleDate, setIsErrorSingleDate] = useState(false)
  const [isErrorTime, setIsErrorTime] = useState(false)
  const [snackOpen, setSnackOpen] = useState({ isOpen: false, message: '' })
  const [isExperiencesEnded, setIsExperienceEnded] = useState(false)
  const [isServiceBlocked, setIsServiceBlocked] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null)
  const [servicesBlockeds, setServicesBlockeds] = useState([])
  const [isServicesBlocked, setIsServicesBlocked] = useState(false)
  const [timedBlockersAlert, setTimedBlocksAlert] = useState(true)
  const [isAvailableCapacity, setIsAvailableCapacity] = useState(false)
  const [isPreviousDaysOk, setisPreviousDaysOk] = useState(false)
  // const [experienceDisponibility, setExperienceDisponibility] = useState(false)
  const [openSnackBarCapacity, setOpenSnackBarCapacity] = useState(false)
  const [openSnackBarMinDays, setOpenSnackBarMinDays] = useState(false)
  const [reservasPostToday, setReservasPostToday] = useState([])
  const [reservations, setReservations] = useState()
  const [scheduleDays, setScheduleDays] = useState([])

  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [minDateSelect, setMinDateSelect] = useState('')
  const [openTimeSnack, setOpenTimeSnack] = useState(false)
  const [isTimeAvailable, setIsTimeAvailable] = useState(false)
  const [day, setDay] = useState(false)
  const [specificTimes, setSpecificTimes] = useState()
  const [personsPerReserv, setPersonsPerReserv] = useState()
  const [maxPassengers, setMaxPassengers] = useState()
  const [openSnackPassengers, setOpenSnackPassengers] = useState(false)
  const [isPassengersCapacity, setIiPassengersCapacity] = useState(true)
  const [selectedDates, setSelectedDates] = useState([])
  const [daysWithHours, setDaysWithHours] = useState()
  const [initialized, setInitialized] = useState(false)
  const [resources, setResources] = useState([])
  const [availabilityInResourceDay, setAvailabilityInResourceDay] = useState([])
  // const personsLimit =
  //   singleExperience.type === 'SINGLE'
  //     ? '1'
  //     : singleExperience.type === 'GROUP'
  //     ? `${singleExperience.typePersons}`
  //     : singleExperience.type === 'PXQ'
  //     ? `${singleExperience.typePersons}`
  //     : null

  const treeData = []

  dayjs.extend(updateLocale)
  dayjs.updateLocale('en', {
    weekStart: 1,
  })

  function mapOrder(array, order) {
    const orderedArray = [...array] // Clonamos el arreglo para no modificar el original

    orderedArray.sort(function (a, b) {
      const A = a
      const B = b

      if (order.indexOf(A) > order.indexOf(B)) {
        return 1
      } else {
        return -1
      }
    })

    return orderedArray
  }

  useEffect(() => {
    const data = { agencyId: agency.key, experienceId: singleExperience.key }

    async function fetchData() {
      const fetchedResources = await getResourcesByDayAndHour(data)
      setResources(fetchedResources)
    }

    fetchData()
  }, [])

  // functon para traerme todos los usos de todos los recursos asociados a la experincia
  const getAvailabilityAndFilterHours = async () => {
    const filteredResources = resources?.filter((resource) => {
      return resource?.idsExperiences?.includes(singleExperience.key) && resource.isActive
    })

    if (filteredResources.length > 0) {
      try {
        let lastAvailability = []
        for (const resource of filteredResources) {
          const availability = await checkAvailabilityHotels(agency.key, resource.id); // esta mal le nombre, trae los aviability de los recursos (uso de recursos)
          availability.forEach((avail) => lastAvailability.push(avail))
        }
        setAvailabilityInResourceDay(lastAvailability);
      } catch (error) {
        console.error(error);
      }
    }
  }

  const checkPxqTable = () => {
    let status = false

    if (singleExperience?.priceQuantity?.length > 0) {
      status = singleExperience?.priceQuantity?.some((p) => {
        return (
          p?.price === 0 ||
          p?.price === '' ||
          p?.from === 0 ||
          p?.from === '' ||
          p?.to === 0 ||
          p?.to === ''
        )
      })
    }

    return status
  }
  const resultPxq = checkPxqTable()

  useEffect(() => {
    addHoursToDates()
  }, [selectedDates])

  useEffect(() => {
    if (
      hotDeal === undefined ||
      hotDeal === null ||
      !hotDeal ||
      Object.keys(hotDeal).length === 0
    ) {
      return null
    } else if (hotDeal && hotDeal?.giftCard?.isGiftCard) {
      setIsGiftCard(true)
      setValue(1)
      ifGiftCardTime()
    }
  }, [])

  useEffect(() => {
    if (hotDeal && singleExperience.partialPercentage === 0) {
      handleGuestAmount(hotDeal.persons, 'adult')

      setSingleDate(new Date(hotDeal.day))
      setSelectedDate(dayjs(hotDeal.day))
      setTime(hotDeal.hour)
    }
  }, [hotDeal, singleExperience])

  useEffect(() => {
    const daysOfWeek = []
    Object.entries(schedule).forEach(([key, value]) => {
      if (key === 'days') {
        daysOfWeek.push(value)
      }
    })
    setScheduleDays(daysOfWeek)
  }, [schedule])

  useEffect(() => {
    const fetchData = async () => {
      const reservations = await getAllReservationsForExperience(
        agency.key,
        singleExperience.key,
      )
      const allReservations = []
      reservations.forEach((r) => {
        if (r.paymentStatus === statePayments.PAYMENT_SUCCESS || r.paymentStatus === statePayments.PARTIAL_PAYMENT) {
          return allReservations.push(r)
        }
      })
      setReservations(allReservations)
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (reservations && reservations.length > 0) {
      const fechaActual = new Date()
      const allReservations = []
      reservations.forEach((r) => {
        if (r.paymentStatus === 'Pago realizado') {
          return allReservations.push(r)
        }
      })
      const reservasFiltradas = allReservations.filter((reserva) => {
        const fechaReserva = new Date(reserva.day)

        return fechaReserva >= fechaActual
      })
      setReservasPostToday(reservasFiltradas)
    }
  }, [reservations])

  function parseTime(timeString) {
    const [time, period] = timeString.split(/([APM]+)/)
    const [hour, minute] = time.split(':').map(Number)
    const isPM = period === 'PM'
    return ((hour % 12) + (isPM ? 12 : 0)) * 60 + minute
  }

  useEffect(() => {
    getScheduleExperience(agency.key, singleExperience.key)
      .then((res) => {
        setSchedule(res)
      })
      .catch((err) => {
        setSnackOpen({
          ...snackOpen,
          isOpen: true,
          message:
            'Hubo un error al realizar su petición. Por favor, intente más tarde.',
        })
      })
  }, [agency.key, singleExperience.key])

  // seteo de horarios en select
  useEffect(() => {
    dataTimeSelect()
    if (singleDate && schedule && schedule.days && scheduleDays.length) {
      const day = singleDate.getDay()
      const filterDay = schedule.days.find((item) => item.day === day)
      let numberOfDay = new Date(selectedDate).getDay()
      const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)
      let year = singleDate.getFullYear()
      let month = (singleDate.getMonth() + 1).toString().padStart(2, '0')
      let dayForm = singleDate.getDate().toString().padStart(2, '0')
      const formatDate = year + '-' + month + '-' + dayForm
      if (filterDay) {
        const times = [
          '12:00AM',
          '12:15AM',
          '12:30AM',
          '12:45AM',
          '01:00AM',
          '01:15AM',
          '01:30AM',
          '01:45AM',
          '02:00AM',
          '02:15AM',
          '02:30AM',
          '02:45AM',
          '03:00AM',
          '03:15AM',
          '03:30AM',
          '03:45AM',
          '04:00AM',
          '04:15AM',
          '04:30AM',
          '04:45AM',
          '05:00AM',
          '05:15AM',
          '05:30AM',
          '05:45AM',
          '06:00AM',
          '06:15AM',
          '06:30AM',
          '06:45AM',
          '07:00AM',
          '07:15AM',
          '07:30AM',
          '07:45AM',
          '08:00AM',
          '08:15AM',
          '08:30AM',
          '08:45AM',
          '09:00AM',
          '09:15AM',
          '09:30AM',
          '09:45AM',
          '10:00AM',
          '10:15AM',
          '10:30AM',
          '10:45AM',
          '11:00AM',
          '11:15AM',
          '11:30AM',
          '11:45AM',
          '12:00PM',
          '12:15PM',
          '12:30PM',
          '12:45PM',
          '01:00PM',
          '01:15PM',
          '01:30PM',
          '01:45PM',
          '02:00PM',
          '02:15PM',
          '02:30PM',
          '02:45PM',
          '03:00PM',
          '03:15PM',
          '03:30PM',
          '03:45PM',
          '04:00PM',
          '04:15PM',
          '04:30PM',
          '04:45PM',
          '05:00PM',
          '05:15PM',
          '05:30PM',
          '05:45PM',
          '06:00PM',
          '06:15PM',
          '06:30PM',
          '06:45PM',
          '07:00PM',
          '07:15PM',
          '07:30PM',
          '07:45PM',
          '08:00PM',
          '08:15PM',
          '08:30PM',
          '08:45PM',
          '09:00PM',
          '09:15PM',
          '09:30PM',
          '09:45PM',
          '10:00PM',
          '10:15PM',
          '10:30PM',
          '10:45PM',
          '11:00PM',
          '11:15PM',
          '11:30PM',
          '11:45PM',
        ]
        const ordered_array = mapOrder(filterDay.time, times)
        const currentTime = new Date()
        const currentHour = currentTime.getHours()
        const currentMinute = currentTime.getMinutes()
        const currentTimeInMinutes = currentHour * 60 + currentMinute
        // Obtener la hora de la fecha seleccionada
        const selectedHour = singleDate.getHours()
        const selectedMinute = singleDate.getMinutes()
        const selectedTimeInMinutes = selectedHour * 60 + selectedMinute
        let filteredArray
        // Comparar la fecha seleccionada con la fecha actual
        if (singleDate >= currentTime) {
          // Si la fecha seleccionada es mayor o igual a la fecha actual, usar todos los horarios
          filteredArray = ordered_array
        } else if (selectedTimeInMinutes > currentTimeInMinutes) {
          // Si la hora seleccionada es mayor que la hora actual, usar todos los horarios
          filteredArray = ordered_array
        } else {
          // Si la hora seleccionada es igual o menor que la hora actual, filtrar por la hora actual
          filteredArray = ordered_array.filter((time) => {
            const timeInMinutes = parseTime(time)
            return timeInMinutes >= currentTimeInMinutes
          })
        }
        const totalPersons = guestAmount + childAmount

        // seteo de horarios disponibles con / sin recursos
        for (const dateKey in daysWithHours) {
          if (dateKey === formatDate) {
            if (daysWithHours.hasOwnProperty(dateKey)) {
              const hours = daysWithHours[dateKey];
              const matchingReservations = reservations.filter(reservation =>
                hours.some(h => reservation.day === formatDate && h === reservation.hour)
              );

              // Calculate remaining availability by hour
              const availabilityByHour = hours.map(h => {

                const reservationsForHour = matchingReservations.filter(
                  reservation => reservation.hour === h
                );

                if (!!resources.length) {
                  // Calculate the availability for each resource
                  const availabilityPerHour = resources.map(res => {
                    const matchingAviabilities = availabilityInResourceDay
                      .filter((av) => av.day === formatDate && h === av.hour && av.resourceId === res.id)
                      .reduce((acc, av) => {
                        // Check if the hour already exists in the accumulator
                        const existing = acc.find(item => item.hour === av.hour);
                        if (existing) {
                          // Accumulate the 'used' value for existing hours
                          existing.used += av.used;
                        } else {
                          // Add new hour with its 'used' value
                          acc.push({ day: av.day, hour: av.hour, used: av.used });
                        }
                        return acc;
                      }, []);

                    const matchingAviabilitiesUsed = !!res.isPrivate ? matchingAviabilities.length : !!matchingAviabilities.length ? matchingAviabilities[0].used : 0
                    let remainingAvailability = 0;
                    if (res.isPrivate) {
                      // For private resources: Quantity - resources used
                      remainingAvailability = res.quantity - matchingAviabilitiesUsed - 1; //menos la reserva actual
                    } else {
                      // For shared resources: Quota - total reservations
                      const totalQuotaForResource = res.quota;
                      remainingAvailability = totalQuotaForResource - matchingAviabilitiesUsed - totalPersons; // menos la cantidad de la reserva actual
                    }
                    return {
                      resourceId: res.id,
                      isPrivate: res.isPrivate,
                      remainingAvailability,
                    };
                  });

                  // Determine if the hour is available based on all resources
                  const isAvailable = availabilityPerHour.every(({ remainingAvailability }) => remainingAvailability >= 0);

                  return {
                    hour: h,
                    isAvailable,
                  };
                } else {
                  // Sin recursos
                  // SINGLE //
                  // Calcula el total de pasajeros 
                  const calculateTotalPersons = (reservations) =>
                    reservations.reduce((totalPersons, reservation) => totalPersons + reservation.persons, 0);

                  //Verifica la disponibilidad general y luego verifica la disponibilidad por hora si es necesario
                  const checkReservations = (hours, selectedDay, matchingReservations, totalPersons) => {
                    // Calcular disponibilidad por hora
                    const availabilityByHour = hours.map(hour => {
                      const reservationsForHour = matchingReservations.filter(reservation => reservation.hour === hour);
                      const passengersForHour = calculateTotalPersons(reservationsForHour);
                      const remainingAvailabilityForHour = selectedDay.disponibility - passengersForHour;
                      return { hour, remainingAvailability: remainingAvailabilityForHour };
                    });
                    // Check si alguna hora tiene disponibilidad
                    const hasAvailableHour = availabilityByHour.some(({ hour, remainingAvailability }) => hour === h && remainingAvailability >= totalPersons);
                    return hasAvailableHour; // Return false si hay aun que sea una hora con disponibilidad
                  };

                  // GROUP //
                  //Verifica la disponibilidad general y luego verifica la disponibilidad por hora si es necesario
                  const checkReservationsForGroup = (hours, selectedDay, matchingReservations, totalPersons) => {
                    // Calcular disponibilidad por hora
                    const availabilityByHour = hours.map(hour => {
                      const reservationsForHour = matchingReservations.filter(reservation => reservation.hour === hour);
                      const remainingAvailabilityForHour = selectedDay.disponibility - reservationsForHour.length;
                      return { hour, remainingAvailability: remainingAvailabilityForHour };
                    });


                    // Check si alguna hora tiene disponibilidad
                    const hasAvailableHour = availabilityByHour.some(({ hour, remainingAvailability }) => hour === h && remainingAvailability >= 1);
                    return hasAvailableHour; // Return false si hay aun que sea una hora con disponibilidad
                  };
                  // Determine if the hour is available based on all resources
                  const isAvailable = singleExperience.type === 'GROUP' ?
                    checkReservationsForGroup(hours, selectedDay, matchingReservations) :
                    checkReservations(hours, selectedDay, matchingReservations, totalPersons)
                  return {
                    hour: h,
                    isAvailable,
                  };
                }
              });

              // Filter hours with availability
              const filteredHours = availabilityByHour
                .filter(({ isAvailable }) => isAvailable)
                .map(({ hour }) => hour);
              filteredHours?.forEach((t) => treeData.push({ value: t, title: t }));
              setTimeSelect(filteredHours);
              setIsDisableTime(false);
            } else {
              setTimeSelect(filteredArray);
            }
          }
        }
      }
    }
  }, [singleDate, schedule, scheduleDays])

  useEffect(() => {
    const isValidDate =
      day &&
      Object.prototype.toString.call(day) === '[object Date]' &&
      !isNaN(day)
    if (singleExperience?.specificDates?.length > 0) {
      return null
    } else if (isValidDate && (!timeSelect || timeSelect.length === 0)) {
      setOpenTimeSnack(true)
      setIsTimeAvailable(true)
    }
  }, [day, timeSelect])

  useEffect(() => {
    // specificDatesTimeSelect(selectDate)
    setisPreviousDaysOk(false)
    var timeleft = 10
    var downloadTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(downloadTimer)
        setTimedBlocksAlert(false)
      }
      timeleft -= 1
    }, 1000)

    validEndPeriodDate()
    // setTimeSelectDisponibility()

    if (
      !selectedAddons.length &&
      singleExperience.addons &&
      singleExperience.addons.length
    ) {
      const selected = singleExperience.addons.map((item) => ({
        ...item,
        selected: false,
      }))
      setSelectedAddons(selected)
    }
  }, [selectedDate])

  useEffect(() => {
    resetTotalPersons()
  }, [selectedAddons])

  useEffect(() => {
    getServicesBlockeds()
  }, [])

  const resetSelectedAddons = () => {
    const selected = singleExperience.addons.map((item) => ({
      ...item,
      selected: false,
    }))
    setSelectedAddons([])
    setSelectedAddons(selected)
  }
  const handleMinDate = () => {
    const { dateInit } = singleExperience
    if (singleExperience && singleExperience?.specificDates?.length > 0) {
      const formattedDates = []
      singleExperience?.specificDates?.forEach((item) => {
        const { day, month, year } = item.startDate
        const startDateFormatted = new Date(year, month - 1, day)
        formattedDates.push(startDateFormatted)
      })
      const minDate = formattedDates.reduce(
        (min, date) => (date < min ? date : min),
        formattedDates[0],
      )
      const date = new Date(minDate)
      return date
    }
    if (dateInit) {
      const currentDateMl = Date.now();
      const current = new Date(currentDateMl)
      const addToDate = singleExperience.previousDays ? singleExperience.previousDays - 1 : 0
      current.setDate(current.getDate() + addToDate);
      const init = new Date(dateInit)

      if (current > init) {
        return current
      } else {
        return init
      }
    } else {
      return new Date()
    }
  }
  const specificDatesTimeSelect = (date) => {
    const datesWithTimes = {}
    const actualDate = new Date(singleDate)
    singleExperience?.specificDates?.forEach((item) => {
      const { day, month, year } = item.startDate
      const startDateFormatted = new Date(year, month - 1, day)
      const dateKey = startDateFormatted.toISOString().split('T')[0]

      if (!datesWithTimes[dateKey]) {
        datesWithTimes[dateKey] = {
          date: startDateFormatted,
          hours: [item.hour],
        }
      } else {
        datesWithTimes[dateKey].hours.push(item.hour)
      }

      const duplicatedDatesWithTimes = Object.values(datesWithTimes).filter(
        (dateObj) => dateObj.hours.length > 1,
      )

      if (
        duplicatedDatesWithTimes.length > 0 &&
        date.toDateString() === duplicatedDatesWithTimes[0].date.toDateString()
      ) {
        setSpecificTimes(duplicatedDatesWithTimes[0].hours)
      } else if (startDateFormatted.toDateString() === date.toDateString()) {
        const selectedHour = formatTime(item.hour)
        setSpecificTimes(selectedHour)
      }
    })

    // Filtrar las fechas que tienen más de un horario

    // Hacer algo con las fechas duplicadas y sus horarios

    // Resto de tu lógica...
  }

  const selectMaxPassengers = (valueTime) => {
    let selectedDate = new Date(singleDate)

    let year = selectedDate.getFullYear()
    let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
    let day = selectedDate.getDate().toString().padStart(2, '0')
    let numberOfDay = selectedDate.getDay()
    const formatDate = year + '-' + month + '-' + day
    const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

    if (selectedDay && selectedDay.disponibility >= guestAmount) {
      const matchingReservations = reservations.filter((reservation) => {
        return reservation.day === formatDate && reservation.hour === valueTime
      })
      if (
        singleExperience.type === 'SINGLE' ||
        singleExperience.type === 'PXQ'
      ) {
        if (singleExperience?.specificDates?.length > 0) {
          const specificCapacity = []
          singleExperience.specificDates.forEach((d) => {
            const date = new Date(
              d.startDate.year,
              d.startDate.month - 1,
              d.startDate.day,
            )
            const dateTimestamp = date.getTime()
            const selectedDateTimestamp = selectedDate.getTime()

            if (dateTimestamp === selectedDateTimestamp) {
              specificCapacity.push(d.capacity)
            }
          })

          const remainingAvailability =
            specificCapacity[0] -
            matchingReservations.reduce((totalPersons, reservation) => {
              return totalPersons + reservation.persons
            }, 0)
          setIiPassengersCapacity(true)
          setOpenSnackPassengers(true)
          return setMaxPassengers(remainingAvailability)
        }
        let totalPersons = 0
        for (let reserva of matchingReservations) {
          if (reserva.persons) {
            totalPersons += reserva.persons
          }
        }

        const maxPassengers = selectedDay.disponibility - totalPersons
        setMaxPassengers(maxPassengers)
        if (maxPassengers <= 0) {
          setIsAvailableCapacity(true)
          setOpenSnackBarCapacity(true)
        } else {
          setIsAvailableCapacity(false)
          setOpenSnackBarCapacity(false)
        }
      } else if (singleExperience.type === 'GROUP') {
        setMaxPassengers(singleExperience.typePersons)
      }
    }
  }

  const isDayAvailable = () => {
    let selectedDate = new Date(singleDate)

    let year = selectedDate.getFullYear()
    let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
    let day = selectedDate.getDate().toString().padStart(2, '0')
    let numberOfDay = selectedDate.getDay()
    const formatDate = year + '-' + month + '-' + day
    const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

    if (selectedDay) {
      const matchingReservations = reservations.filter((reservation) => {
        return reservation.day === formatDate && reservation.hour === time
      })
      if (singleExperience.type === 'SINGLE') {
        if (singleExperience?.specificDates?.length > 0) {
          if (matchingReservations.length > 0) {
            const specificCapacity = []
            singleExperience.specificDates.forEach((d) => {
              const date = new Date(
                d.startDate.year,
                d.startDate.month - 1,
                d.startDate.day,
              )
              const dateTimestamp = date.getTime()
              const selectedDateTimestamp = selectedDate.getTime()

              if (dateTimestamp === selectedDateTimestamp) {
                specificCapacity.push(d.capacity)
              }
            })

            const remainingAvailability =
              selectedDay.disponibility -
              matchingReservations.reduce((totalPersons, reservation) => {
                return totalPersons + reservation.persons
              }, 0)

            if (remainingAvailability >= guestAmount) {
              setIsAvailableCapacity(false)
              setOpenSnackBarCapacity(false)
              return true
            } else {
              setIsAvailableCapacity(true)
              setOpenSnackBarCapacity(true)
              return false
            }
          } else {
            setIsAvailableCapacity(false)
            setOpenSnackBarCapacity(false)
            return true
          }
        }
        if (matchingReservations.length > 0) {
          const remainingAvailability =
            selectedDay.disponibility -
            matchingReservations.reduce((totalPersons, reservation) => {
              return totalPersons + reservation.persons
            }, 0)
          if (remainingAvailability >= guestAmount) {
            setIsAvailableCapacity(false)
            setOpenSnackBarCapacity(false)
            return true
          } else {
            setIsAvailableCapacity(true)
            setOpenSnackBarCapacity(true)
            return false
          }
        } else {
          setIsAvailableCapacity(false)
          setOpenSnackBarCapacity(false)
          return true
        }
      } else if (singleExperience.type === 'PXQ') {
        if (singleExperience?.specificDates?.length > 0) {
          if (matchingReservations.length > 0) {
            const specificCapacity = []
            singleExperience.specificDates.forEach((d) => {
              const date = new Date(
                d.startDate.year,
                d.startDate.month - 1,
                d.startDate.day,
              )
              const dateTimestamp = date.getTime()
              const selectedDateTimestamp = selectedDate.getTime()

              if (dateTimestamp === selectedDateTimestamp) {
                specificCapacity.push(d.capacity)
              }
            })

            const remainingAvailability =
              selectedDay.disponibility -
              matchingReservations.reduce((totalPersons, reservation) => {
                return totalPersons + reservation.persons
              }, 0)

            if (remainingAvailability >= guestAmount) {
              setIsAvailableCapacity(false)
              setOpenSnackBarCapacity(false)
              return true
            } else {
              setIsAvailableCapacity(true)
              setOpenSnackBarCapacity(true)
              return false
            }
          } else {
            setIsAvailableCapacity(false)
            setOpenSnackBarCapacity(false)
            return true
          }
        }
        if (matchingReservations.length > 0) {
          const remainingAvailability =
            selectedDay.disponibility -
            matchingReservations.reduce((totalPersons, reservation) => {
              return totalPersons + reservation.persons
            }, 0)

          if (remainingAvailability >= guestAmount) {
            setIsAvailableCapacity(false)
            setOpenSnackBarCapacity(false)
            return true
          } else {
            setIsAvailableCapacity(true)
            setOpenSnackBarCapacity(true)
            return false
          }
        } else {
          setIsAvailableCapacity(false)
          setOpenSnackBarCapacity(false)
          return true
        }
      } else if (singleExperience.type === 'GROUP') {
        if (singleExperience?.specificDates?.length > 0) {
          if (matchingReservations.length > 0) {
            const specificCapacity = []
            singleExperience.specificDates.forEach((d) => {
              const date = new Date(
                d.startDate.year,
                d.startDate.month - 1,
                d.startDate.day,
              )
              const dateTimestamp = date.getTime()
              const selectedDateTimestamp = selectedDate.getTime()

              if (dateTimestamp === selectedDateTimestamp) {
                specificCapacity.push(d.capacity)
              }
            })
            if (matchingReservations.length >= specificCapacity[0]) {
              setIsAvailableCapacity(true)
              setOpenSnackBarCapacity(true)
              return false
            } else {
              setIsAvailableCapacity(false)
              setOpenSnackBarCapacity(false)
              return true
            }
          } else {
            setIsAvailableCapacity(false)
            setOpenSnackBarCapacity(false)
            return true
          }
        }
        if (matchingReservations.length > 0) {
          // let totalPersons = 0
          // for (let reserva of matchingReservations) {
          //   if (reserva.persons) {
          //     totalPersons += reserva.persons
          //   }
          // }
          // const availablePassengers =
          //   selectedDay.disponibility * singleExperience.typePersons
          // const finalDisponibility = availablePassengers - totalPersons

          if (matchingReservations.length >= selectedDay.disponibility) {
            setIsAvailableCapacity(true)
            setOpenSnackBarCapacity(true)
            return false
          } else {
            setIsAvailableCapacity(false)
            setOpenSnackBarCapacity(false)
            return true
          }
        } else {
          setIsAvailableCapacity(false)
          setOpenSnackBarCapacity(false)
          return true
        }
      }
    }

    setIsAvailableCapacity(true)
    setOpenSnackBarCapacity(true)
    return false
  }

  const handleDateAndTime = (arraySchedule, date) => {
    const day = date.getDay()
    const filterDay = arraySchedule.days.filter((item) => item.day === day)

    let times = [
      '12:00AM',
      '12:15AM',
      '12:30AM',
      '12:45AM',
      '01:00AM',
      '01:15AM',
      '01:30AM',
      '01:45AM',
      '02:00AM',
      '02:15AM',
      '02:30AM',
      '02:45AM',
      '03:00AM',
      '03:15AM',
      '03:30AM',
      '03:45AM',
      '04:00AM',
      '04:15AM',
      '04:30AM',
      '04:45AM',
      '05:00AM',
      '05:15AM',
      '05:30AM',
      '05:45AM',
      '06:00AM',
      '06:15AM',
      '06:30AM',
      '06:45AM',
      '07:00AM',
      '07:15AM',
      '07:30AM',
      '07:45AM',
      '08:00AM',
      '08:15AM',
      '08:30AM',
      '08:45AM',
      '09:00AM',
      '09:15AM',
      '09:30AM',
      '09:45AM',
      '10:00AM',
      '10:15AM',
      '10:30AM',
      '10:45AM',
      '11:00AM',
      '11:15AM',
      '11:30AM',
      '11:45AM',
      '12:00PM',
      '12:15PM',
      '12:30PM',
      '12:45PM',
      '01:00PM',
      '01:15PM',
      '01:30PM',
      '01:45PM',
      '02:00PM',
      '02:15PM',
      '02:30PM',
      '02:45PM',
      '03:00PM',
      '03:15PM',
      '03:30PM',
      '03:45PM',
      '04:00PM',
      '04:15PM',
      '04:30PM',
      '04:45PM',
      '05:00PM',
      '05:15PM',
      '05:30PM',
      '05:45PM',
      '06:00PM',
      '06:15PM',
      '06:30PM',
      '06:45PM',
      '07:00PM',
      '07:15PM',
      '07:30PM',
      '07:45PM',
      '08:00PM',
      '08:15PM',
      '08:30PM',
      '08:45PM',
      '09:00PM',
      '09:15PM',
      '09:30PM',
      '09:45PM',
      '10:00PM',
      '10:15PM',
      '10:30PM',
      '10:45PM',
      '11:00PM',
      '11:15PM',
      '11:30PM',
      '11:45PM',
    ]

    function mapOrder(array, order) {
      array.sort(function (a, b) {
        var A = a,
          B = b

        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        } else {
          return -1
        }
      })

      return array
    }

    let ordered_array = mapOrder(filterDay[0].time, times)

    setTimeSelect(ordered_array)
    setIsDisableTime(false)
  }

  const validateSingleDate = () => {
    if (singleDate === null) {
      setIsErrorSingleDate(true)
      return false
    } else {
      setIsErrorSingleDate(false)
      return true
    }
  }

  const validTime = () => {
    if (time) {
      setIsErrorTime(false)
      return true
    } else {
      setIsErrorTime(true)
      return false
    }
  }

  const validGuestAmount = () => {
    if (guestAmount === 0) {
      setIsErrorGuestAmount(true)
      return false
    }

    setIsErrorGuestAmount(false)
    return true
  }

  const validateReservationPrice = () => {
    if (reservationPrice < 1000) {
      return false
    }
    return true
  }

  const validateForm = async () => {
    const boolPreviousDays = validPreviousDays()
    const boolSingleDate = validateSingleDate()
    const boolTime = validTime()
    const boolGuestAmount = validGuestAmount()
    const boolReservationPrice = validateReservationPrice()
    const availableDay = isDayAvailable()

    if (!boolReservationPrice) {
      setSnackOpen({
        ...snackOpen,
        isOpen: true,
        message: 'El total no puede ser menos a $1000',
      })
      return
    }

    // if (!boolPreviousDays && !giftCard) {
    //   setisPreviousDaysOk(true)
    //   setSnackOpen({
    //     ...snackOpen,
    //     isOpen: true,
    //     message: `Esta experiencia necesita reservarse ${singleExperience.previousDays} días previos al día en que se realiza.`,
    //   })
    //   return
    // }

    console.log(
      boolSingleDate,
      boolTime,
      boolGuestAmount,
      availableDay,
      singleDate,
    )
    if (boolSingleDate && boolTime && boolGuestAmount) {
      if (singleExperience.partialPercentage > 0) {
        setPartialPrice(
          ((!!reservationPrice
            ? reservationPrice + addonsPrice + addonsPersonsPrice
            : 0) *
            singleExperience.partialPercentage) /
          100,
        )
        handleNext()
      } else {
        handleNext()
      }
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      validateForm()
    }
  }

  const guestIsDisable = () => {
    if (isExperiencesEnded) {
      return true
    }

    // if (!singleDate) {
    //   return true
    // }

    return false
  }

  const handleAddons = (event, addon, index) => {
    if (event) {
      const copyAddons = [...selectedAddons]
      copyAddons[index] = { ...copyAddons[index], selected: true }
      setSelectedAddons(copyAddons)
      const totalGuest = guestAmount + childAmount
      //Se agrega el precio del addon
      const addPrice = addonsPrice + totalGuest * addon.price
      setAddonsPrice(addPrice)
      setTotalPrice(addPrice + reservationPrice)
      setPartialPrice(
        (addPrice + reservationPrice) *
        (singleExperience.partialPercentage / 100),
      )
    } else {
      const copyAddons = [...selectedAddons]
      copyAddons[index] = { ...copyAddons[index], selected: false }
      setSelectedAddons(copyAddons)
      const totalGuest = guestAmount + childAmount
      //se resta el precio del addon
      const minusPrice = addonsPrice - totalGuest * addon.price
      setAddonsPrice(minusPrice)
      setTotalPrice(reservationPrice + minusPrice)
      setPartialPrice(
        (reservationPrice + minusPrice) *
        (singleExperience.partialPercentage / 100),
      )
    }
  }

  const handleAddonsSpecial = (event, addon, index) => {
    const copyAddons = [...selectedAddons]
    copyAddons[index] = { ...copyAddons[index], selected: event }
    setSelectedAddons(copyAddons)
    totalizerAddons()
  }

  const handleChangeQty = (quantity, addon, index) => {
    selectedAddons[index].quantity = quantity
    setSelectedAddons(selectedAddons)
    totalizerAddons()
  }

  const totalizerAddons = () => {
    let sum = 0
    const addons = selectedAddons.filter(
      (fil) => fil.isSpecial && fil.selected && fil.quantity > 0,
    )
    if (addons.length > 0) {
      addons.map((addon, index) => {
        sum = sum + addon.price * addon.quantity
      })
      setAddonsPersonsPrice(sum)
      // setTotalAddonsPersons(sum)
    } else {
      setAddonsPersonsPrice(0)
    }
  }

  const resetTotalPersons = () => {
    const total = 0
    setTimeout(() => {
      setAddonsPersonsPrice(total)
      totalizerAddons()
    }, 500)
  }

  const validateServiceHour = async (hour) => {
    const selectedDay = moment(singleDate).day()

    const data = {
      agencyId: agency.key,
      experienceId: singleExperience.key,
      day: formatDateToDB(singleDate),
      hour: hour,
    }

    const serviceAvailable = await getServiceByDayAndHour(data)

    if (serviceAvailable.isBlocked) {
      setTime('')
      setIsServiceBlocked(true)
      return
    }

    //El servicio existe, se valida si tiene disponibilidad
    if (serviceAvailable.key) {
      if (serviceAvailable.isBlocked) {
        setSnackOpen({
          ...snackOpen,
          isOpen: true,
          message:
            'La experiencia no se encuentra disponible en la fecha selecciona. Por favor, seleccione otra fecha.',
        })
        setTime('')

        setIsServiceBlocked(true)
        return false
      } else {
        setIsServiceBlocked(false)
      }
    }
  }

  const handleMaxDate = () => {
    const { dateEnd } = singleExperience
    if (singleExperience && singleExperience?.specificDates?.length > 0) {
      const formattedDates = []
      singleExperience?.specificDates?.forEach((item) => {
        const { day, month, year } = item.startDate
        const startDateFormatted = new Date(year, month - 1, day)
        formattedDates.push(startDateFormatted)
      })
      const maxDate = formattedDates.reduce(
        (max, date) => (date > max ? date : max),
        formattedDates[0],
      )
      const date = new Date(maxDate)
      date.setDate(date.getDate() + 1)
      return date
    }
    if (dateEnd) {
      return new Date(dateEnd)
    }
  }

  const validEndPeriodDate = () => {
    const { dateEnd } = singleExperience

    if (dateEnd) {
      const finalDate = new Date(dateEnd)
      const currentDate = new Date()

      if (currentDate > finalDate) {
        setIsExperienceEnded(true)
        setOpenSnackBar(true)
      } else {
        setIsExperienceEnded(false)
      }
    } else {
      setIsExperienceEnded(false)
    }
  }

  const handlePanelChange = (value, mode) => {
    if (mode === 'date') {
      const currentMonth = dayjs(value)
      const daysInMonth = currentMonth.daysInMonth()
      const startDate = currentMonth.startOf('month')
      const datesArray = Array.from({ length: daysInMonth }, (_, index) =>
        startDate.add(index, 'days'),
      )

      const formattedDates = datesArray.map((date) => date.format('YYYY-MM-DD'))
      setSelectedDate()

      setSelectedDates(formattedDates)
    }
  }

  const handleOpenChange = async (open) => {
    await getAvailabilityAndFilterHours()
    if (open && !initialized) {
      // Ejecutar la lógica cuando el DatePicker se abre por primera vez
      const currentMonth = dayjs()
      const daysInMonth = currentMonth.daysInMonth()
      const startDate = currentMonth.startOf('month')
      const datesArray = Array.from({ length: daysInMonth }, (_, index) =>
        startDate.add(index, 'days'),
      )

      const formattedDates = datesArray.map((date) => date.format('YYYY-MM-DD'))
      setSelectedDates(formattedDates)

      setInitialized(true)
    }
  }

  const addHoursToDates = () => {
    if (singleExperience?.specificDates?.length > 0) {
      const daysWithHours = {};
      singleExperience.specificDates.forEach(({ startDate, hour }) => {
        const date = `${startDate.year}-${String(startDate.month).padStart(2, '0')}-${String(startDate.day).padStart(2, '0')}`;
        if (!daysWithHours[date]) {
          daysWithHours[date] = [];
        }
        daysWithHours[date].push(formatTime(hour));
      });
      setDaysWithHours(daysWithHours);
    } else if (selectedDates.length > 0) {
      const dayNumbers = selectedDates.map((date) => dayjs(date).day());
      const schedulePeriodicity = schedule.days;
      const daysWithHours = {};
      dayNumbers.forEach((dayNumber, index) => {
        const arrayScheduleHours = schedulePeriodicity[dayNumber].time;
        if (arrayScheduleHours.length > 0) {
          daysWithHours[selectedDates[index]] = arrayScheduleHours;
        }
      });
      setDaysWithHours(daysWithHours);
    }
  }

  function formatTime(time) {
    const [hours, minutes] = time.split(':')
    let formattedHours = parseInt(hours, 10)
    let period = 'AM'

    if (formattedHours >= 12) {
      period = 'PM'
      if (formattedHours > 12) {
        formattedHours -= 12
      }
    }

    return `${formattedHours.toString().padStart(2, '0')}:${minutes}${period}`
  }

  const filterDates = (date) => {
    if (singleExperience?.specificDates?.length > 0) {
      return filterDatesSpecifics(date)
    } else {
      return filterDatesRecurrent(date)
    }
  }

  // check alejandro
  const filterDatesSpecifics = (date) => {
    const selectedDate = new Date(date);
    const datesWithTimes = [];
    const totalPersons = guestAmount + childAmount
    let year = selectedDate.getFullYear()
    let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
    let day = selectedDate.getDate().toString().padStart(2, '0')
    let numberOfDay = selectedDate.getDay()
    const formatDate = year + '-' + month + '-' + day
    const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

    //seteo datesWithTimes
    singleExperience?.specificDates?.forEach((item) => {
      const { day, month, year } = item.startDate
      const startDateFormatted = new Date(year, month - 1, day)
      const dateKey = startDateFormatted.toISOString().split('T')[0]

      const itemHour = formatTime(item.hour)
      if (!datesWithTimes[dateKey]) {
        datesWithTimes[dateKey] = {
          date: startDateFormatted,
          hours: [{ hour: itemHour, capacity: item.capacity || 0 }],
        }
      } else {
        datesWithTimes[dateKey].hours.push({
          hour: itemHour,
          capacity: item.capacity || 0,
        })
      }
    })

    const filteredResources = resources.filter((resource) => resource.idsExperiences.includes(singleExperience.key) && resource.isActive)
    //si no hay recursos configurados
    if (!filteredResources.length) {
      //si no hay recursos
      if (daysWithHours && Object.keys(daysWithHours).length > 0) {
        // Recorrer las claves (fechas) en daysWithHours
        for (const dateKey in daysWithHours) {
          if (daysWithHours.hasOwnProperty(dateKey)) {
            if (dateKey === formatDate) {
              // Verificar si la fecha actual coincide con la fecha en daysWithHours
              const hours = daysWithHours[dateKey]
              //si el dia tiene disponibilidad
              if (selectedDay && !!selectedDay.disponibility) {
                const matchingReservations = reservations.filter(
                  (reservation) => {
                    return hours.some(
                      (h) =>
                        reservation.day === formatDate &&
                        h === reservation.hour,
                    )
                  },
                )
                // Helpers
                // Calcula el total de pasajeros 
                const calculateTotalPersons = (reservations) =>
                  reservations.reduce((totalPersons, reservation) => totalPersons + reservation.persons, 0);

                // Calcula el total de reservas 
                const calculateTotalReservations = (reservations) => reservations.length;

                // Calcula la disponibilidad restante por hora
                const calculateAvailabilityByHour = (hours, matchingReservations, selectedDay) =>
                  hours.map(h => {
                    const reservationsForHour = matchingReservations.filter(reservation => reservation.hour === h);
                    const passengersForHour = calculateTotalPersons(reservationsForHour);
                    const remainingAvailabilityForHour = selectedDay.disponibility - passengersForHour;
                    return { hour: h, remainingAvailability: remainingAvailabilityForHour };
                  });

                // Calcula la disponibilidad restante por hora para experiencias grupales
                const calculateAvailabilityByHourForGroup = (hours, matchingReservations, selectedDay) =>
                  hours.map(h => {
                    const reservationsForHour = matchingReservations.filter(reservation => reservation.hour === h);
                    const remainingAvailabilityForHour = selectedDay.disponibility - reservationsForHour.length;
                    return { hour: h, remainingAvailability: remainingAvailabilityForHour };
                  });

                // Comprueba si la disponibilidad total es mayor que el número total de reservas  
                const checkAvailability = (disponibility, guestAmount, matchingReservations) => {
                  const remainingAvailability = disponibility - calculateTotalPersons(matchingReservations);
                  return remainingAvailability >= guestAmount ? false : true;
                };

                // Comprueba si la disponibilidad total es mayor que el número total de reservas para experiencias grupales
                const checkAvailabilityForGroup = (disponibility, matchingReservations) => {
                  const remainingAvailability = disponibility - calculateTotalReservations(matchingReservations);
                  return remainingAvailability > 0 ? false : true;
                };

                // Comprueba si hay alguna hora con disponibilidad suficiente
                const checkAvailabilityByHour = (hours, selectedDay, matchingReservations, guestAmount) => {
                  const availabilityByHour = calculateAvailabilityByHour(hours, matchingReservations, selectedDay);
                  const filteredHours = availabilityByHour.filter(({ remainingAvailability }) => remainingAvailability >= guestAmount);
                  return filteredHours.length > 0 ? false : true;
                };

                // Comprueba si hay alguna hora con disponibilidad suficiente para experiencias grupales
                const checkAvailabilityByHourForGroup = (hours, selectedDay, matchingReservations) => {
                  const availabilityByHour = calculateAvailabilityByHourForGroup(hours, matchingReservations, selectedDay);
                  const filteredHours = availabilityByHour.filter(({ remainingAvailability }) => remainingAvailability > 0);
                  return filteredHours.length > 0 ? false : true;
                };

                // Verifica la disponibilidad general y luego verifica la disponibilidad por hora si es necesario
                const checkReservations = (uniqueHours, hours, selectedDay, matchingReservations, totalPersons) => {
                  const remainingAvailability = selectedDay.disponibility - calculateTotalPersons(matchingReservations);
                  if (remainingAvailability >= totalPersons) {
                    return false;
                  } else {
                    return checkAvailabilityByHour(hours, selectedDay, matchingReservations, totalPersons);
                  }
                };

                // Verifica la disponibilidad general y luego verifica la disponibilidad por hora si es necesario para experiencias grupales
                const checkReservationsForGroup = (uniqueHours, hours, selectedDay, matchingReservations) => {
                  const remainingAvailability = selectedDay.disponibility - calculateTotalReservations(matchingReservations);
                  if (remainingAvailability > 0) {
                    return false;
                  } else {
                    return checkAvailabilityByHourForGroup(hours, selectedDay, matchingReservations);
                  }
                };

                // Función check de disponibilida de días
                const checkSingleExperience = (singleExperience, hours, selectedDay, matchingReservations, totalPersons) => {
                  if (singleExperience.type === 'PXQ' || singleExperience.type === 'SINGLE') {
                    if (hours.length < 2) {
                      if (matchingReservations.length > 0) {
                        return checkAvailability(selectedDay.disponibility, totalPersons, matchingReservations);
                      } else {
                        return selectedDay.disponibility >= totalPersons ? false : true;
                      }
                    } else {
                      const hoursOfDay = [...new Set(matchingReservations.map(matchingReservation => matchingReservation.hour))];
                      const uniqueHours = new Set(hoursOfDay);

                      if (matchingReservations.length > 0) {
                        return checkReservations(uniqueHours, hours, selectedDay, matchingReservations, totalPersons);
                      } else {
                        return selectedDay.disponibility >= totalPersons ? false : true;
                      }
                    }
                  } else if (singleExperience.type === 'GROUP') {
                    if (hours.length < 2) {
                      if (matchingReservations.length > 0) {
                        return checkAvailabilityForGroup(selectedDay.disponibility, matchingReservations);
                      } else return false
                    } else {
                      const hoursOfDay = [...new Set(matchingReservations.map(matchingReservation => matchingReservation.hour))];
                      const uniqueHours = new Set(hoursOfDay);

                      if (matchingReservations.length > 0) {
                        return checkReservationsForGroup(uniqueHours, hours, selectedDay, matchingReservations);
                      } else {
                        return checkAvailabilityForGroup(selectedDay.disponibility, matchingReservations);
                      }
                    }
                  }
                };
                console.log(formatDate, checkSingleExperience(singleExperience, hours, selectedDay, matchingReservations, totalPersons))
                return checkSingleExperience(singleExperience, hours, selectedDay, matchingReservations, totalPersons)
              }
            }
          }
        }
        return true
      }
    } else {
      // If there are configured resources
      if (datesWithTimes && Object.keys(datesWithTimes).length > 0) {
        let formatDateFound = false;

        // Iterate over the keys (dates) in datesWithTimes
        for (const dateKey in datesWithTimes) {
          if (datesWithTimes.hasOwnProperty(dateKey)) {
            // Check if the current date matches the date in daysWithHours
            if (dateKey === formatDate) {
              formatDateFound = true;
              let availabilityInDay = [];
              datesWithTimes[dateKey].hours.forEach((hour) => {
                // Iterate through each hour of that specific day and save if it has availability
                if (hour.capacity > 0) {
                  // Filter availabilities for the current hour and date
                  const matchingAvailabilities = availabilityInResourceDay.filter(
                    (av) => hour.hour === av.hour && av.day === formatDate
                  );
                  // Aggregate usage by resource ID
                  const usageByResource = matchingAvailabilities.reduce((acc, { resourceId, used }) => {
                    if (!acc[resourceId]) {
                      acc[resourceId] = 0;
                    }
                    acc[resourceId] += used;
                    return acc;
                  }, {});

                  if (totalPersons > hour.capacity) {
                    availabilityInDay.push(true);
                  } else {
                    // Check if any resource has availability issues
                    const hasIssue = filteredResources.some((resource) => {
                      const resourceUsage = usageByResource[resource.id] || 0;

                      if (resource.isPrivate) {
                        return resource.quantity <= matchingAvailabilities.length;
                      } else {
                        return resource.quota < (resourceUsage + totalPersons);
                      }
                    });
                    // Add the issue status to the availabilityInDay array
                    availabilityInDay.push(hasIssue);
                  }
                }
              });

              // Check if all the times within this day have availability
              // If all times are occupied within the same date, block the day; otherwise, keep it enabled
              const allUnavailable = availabilityInDay.every(item => item === true);
              // Return the result immediately if any availability issue is found
              if (allUnavailable) {
                return true;
              }
            }
          }
        }
        // If formatDate is not found in datesWithTimes, return true
        if (!formatDateFound) {
          return true;
        }
        // If no availability issues were found after checking all dates, return false
        return false;
      } else {
        // Default to true if datesWithTimes is not defined or empty
        return true;
      }
    }
  }

  // check alejandro
  const filterDatesRecurrent = (date) => {
    const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
    const getDay = date.day()
    const selectedDate = new Date(date)
    let year = selectedDate.getFullYear()
    let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
    let day = selectedDate.getDate().toString().padStart(2, '0')
    let numberOfDay = selectedDate.getDay()
    const formatDate = year + '-' + month + '-' + day
    const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)
    const hoursSchedulePeriodicity = schedule.days.sort((a, b) => days.indexOf(a.name) - days.indexOf(b.name));
    const arrayScheduleHours = hoursSchedulePeriodicity[getDay]?.time || [];

    if (arrayScheduleHours.length === 0) {
      return true
    }

    const periodicity = singleExperience.periodicity.indexOf(days[getDay])
    if (periodicity === -1) {
      return true
    }
    const totalPersons = guestAmount + childAmount
    // si la experiencia es PXQ o SINGLE y hay mas participantes que disponibilidad blockea el día
    if (
      singleExperience.type === 'PXQ' ||
      singleExperience.type === 'SINGLE'
    ) {
      if (totalPersons > selectedDay.disponibility) {
        return true
      }
    }

    const filteredResources = resources.filter((resource) => resource.idsExperiences.includes(singleExperience.key) && resource.isActive)
    //si no hay recursos configurados
    if (!filteredResources.length) {
      //si no hay recursos
      if (daysWithHours && Object.keys(daysWithHours).length > 0) {
        // Recorrer las claves (fechas) en daysWithHours
        for (const dateKey in daysWithHours) {
          if (daysWithHours.hasOwnProperty(dateKey)) {
            if (dateKey === formatDate) {
              // Verificar si la fecha actual coincide con la fecha en daysWithHours
              const hours = daysWithHours[dateKey]
              //si el dia tiene disponibilidad
              if (selectedDay && !!selectedDay.disponibility) {
                const matchingReservations = reservations.filter(
                  (reservation) => {
                    return hours.some(
                      (h) =>
                        reservation.day === formatDate &&
                        h === reservation.hour,
                    )
                  },
                )
                // Helpers
                // Calcula el total de pasajeros 
                const calculateTotalPersons = (reservations) =>
                  reservations.reduce((totalPersons, reservation) => totalPersons + reservation.persons, 0);

                // Calcula el total de reservas 
                const calculateTotalReservations = (reservations) => reservations.length;

                // Calcula la disponibilidad restante por hora
                const calculateAvailabilityByHour = (hours, matchingReservations, selectedDay) =>
                  hours.map(h => {
                    const reservationsForHour = matchingReservations.filter(reservation => reservation.hour === h);
                    const passengersForHour = calculateTotalPersons(reservationsForHour);
                    const remainingAvailabilityForHour = selectedDay.disponibility - passengersForHour;
                    return { hour: h, remainingAvailability: remainingAvailabilityForHour };
                  });

                // Calcula la disponibilidad restante por hora para experiencias grupales
                const calculateAvailabilityByHourForGroup = (hours, matchingReservations, selectedDay) =>
                  hours.map(h => {
                    const reservationsForHour = matchingReservations.filter(reservation => reservation.hour === h);
                    const remainingAvailabilityForHour = selectedDay.disponibility - reservationsForHour.length;
                    return { hour: h, remainingAvailability: remainingAvailabilityForHour };
                  });

                // Comprueba si la disponibilidad total es mayor que el número total de reservas  
                const checkAvailability = (disponibility, guestAmount, matchingReservations) => {
                  const remainingAvailability = disponibility - calculateTotalPersons(matchingReservations);
                  return remainingAvailability >= guestAmount ? false : true;
                };

                // Comprueba si la disponibilidad total es mayor que el número total de reservas para experiencias grupales
                const checkAvailabilityForGroup = (disponibility, matchingReservations) => {
                  const remainingAvailability = disponibility - calculateTotalReservations(matchingReservations);
                  return remainingAvailability > 0 ? false : true;
                };

                // Comprueba si hay alguna hora con disponibilidad suficiente
                const checkAvailabilityByHour = (hours, selectedDay, matchingReservations, guestAmount) => {
                  const availabilityByHour = calculateAvailabilityByHour(hours, matchingReservations, selectedDay);
                  const filteredHours = availabilityByHour.filter(({ remainingAvailability }) => remainingAvailability >= guestAmount);
                  return filteredHours.length > 0 ? false : true;
                };

                // Comprueba si hay alguna hora con disponibilidad suficiente para experiencias grupales
                const checkAvailabilityByHourForGroup = (hours, selectedDay, matchingReservations) => {
                  const availabilityByHour = calculateAvailabilityByHourForGroup(hours, matchingReservations, selectedDay);
                  const filteredHours = availabilityByHour.filter(({ remainingAvailability }) => remainingAvailability > 0);
                  return filteredHours.length > 0 ? false : true;
                };

                // Verifica la disponibilidad general y luego verifica la disponibilidad por hora si es necesario
                const checkReservations = (uniqueHours, hours, selectedDay, matchingReservations, totalPersons) => {
                  const remainingAvailability = selectedDay.disponibility - calculateTotalPersons(matchingReservations);
                  if (remainingAvailability >= totalPersons) {
                    return false;
                  } else {
                    return checkAvailabilityByHour(hours, selectedDay, matchingReservations, totalPersons);
                  }
                };

                // Verifica la disponibilidad general y luego verifica la disponibilidad por hora si es necesario para experiencias grupales
                const checkReservationsForGroup = (uniqueHours, hours, selectedDay, matchingReservations) => {
                  const remainingAvailability = selectedDay.disponibility - calculateTotalReservations(matchingReservations);
                  if (remainingAvailability > 0) {
                    return false;
                  } else {
                    return checkAvailabilityByHourForGroup(hours, selectedDay, matchingReservations);
                  }
                };

                // Función check de disponibilida de días
                const checkSingleExperience = (singleExperience, hours, selectedDay, matchingReservations, totalPersons) => {
                  if (singleExperience.type === 'PXQ' || singleExperience.type === 'SINGLE') {
                    if (hours.length < 2) {
                      if (matchingReservations.length > 0) {
                        return checkAvailability(selectedDay.disponibility, totalPersons, matchingReservations);
                      } else {
                        return selectedDay.disponibility >= totalPersons ? false : true;
                      }
                    } else {
                      const hoursOfDay = [...new Set(matchingReservations.map(matchingReservation => matchingReservation.hour))];
                      const uniqueHours = new Set(hoursOfDay);

                      if (matchingReservations.length > 0) {
                        return checkReservations(uniqueHours, hours, selectedDay, matchingReservations, totalPersons);
                      } else {
                        return selectedDay.disponibility >= totalPersons ? false : true;
                      }
                    }
                  } else if (singleExperience.type === 'GROUP') {
                    if (hours.length < 2) {
                      if (matchingReservations.length > 0) {
                        return checkAvailabilityForGroup(selectedDay.disponibility, matchingReservations);
                      }
                    } else {
                      const hoursOfDay = [...new Set(matchingReservations.map(matchingReservation => matchingReservation.hour))];
                      const uniqueHours = new Set(hoursOfDay);

                      if (matchingReservations.length > 0) {
                        return checkReservationsForGroup(uniqueHours, hours, selectedDay, matchingReservations);
                      } else {
                        return checkAvailabilityForGroup(selectedDay.disponibility, matchingReservations);
                      }
                    }
                  }
                };
                return checkSingleExperience(singleExperience, hours, selectedDay, matchingReservations, totalPersons)
              }
            }
          }
        }
      }
    } else {
      if (daysWithHours && Object.keys(daysWithHours).length > 0) {
        let hasAvailabilityIssues = false;
        // Recorrer las claves (fechas) en daysWithHours
        for (const dateKey in daysWithHours) {
          if (daysWithHours.hasOwnProperty(dateKey)) {
            // Verificar si la fecha actual coincide con la fecha en daysWithHours
            if (dateKey === formatDate) {
              const hours = daysWithHours[dateKey];
              // const dayOfWeek = selectedDate.getDay();
              // const dayName = days[dayOfWeek];
              if (selectedDay && selectedDay.disponibility) {
                // Inicializar un array para almacenar el estado de disponibilidad por hora
                let availabilityInDay = [];
                // Iterar a través de cada hora en el día
                hours.forEach((hour) => {
                  // Filter availabilities for the current hour and date
                  const matchingAvailabilities = availabilityInResourceDay.filter(
                    (av) => hour === av.hour && av.day === formatDate
                  );
                  // Aggregate usage by resource ID
                  const usageByResource = matchingAvailabilities.reduce((acc, { resourceId, used }) => {
                    if (!acc[resourceId]) {
                      acc[resourceId] = 0;
                    }
                    acc[resourceId] += used;
                    return acc;
                  }, {});
                  // Check if any resource has availability issues
                  const hasIssue = filteredResources.some((resource) => {
                    const resourceUsage = usageByResource[resource.id] || 0;

                    if (resource.isPrivate) {
                      return resource.quantity <= resourceUsage; /// <= matchingAvailabilities.length
                    } else {
                      return resource.quota < (resourceUsage + totalPersons);
                    }
                  });
                  // Add the issue status to the availabilityInDay array
                  availabilityInDay.push(hasIssue);
                });
                // Verificar si todas las horas del día tienen problemas de disponibilidad
                const allUnavailable = availabilityInDay.every(item => item === true);

                // Retornar verdadero si todas las horas están ocupadas
                if (allUnavailable) {
                  return true;
                }
              }
            }
          }
        }
        // Retornar falso si no se encontraron problemas de disponibilidad después de revisar todas las fechas
        return hasAvailabilityIssues;
      }
      // Default to false if daysWithHours is not defined or empty
      return false;
    }
  }

  const handleGuestAmount = async (value, type) => {
    if (type === 'adult') {
      setIsErrorGuestAmount(false)
      const totalGuest = value + childAmount

      if (
        singleExperience.typePersons === 0 ||
        totalGuest <= singleExperience.typePersons
      ) {
        setGuestAmount(parseInt(value, 10))
        handlePrice(parseInt(value, 10), type)
      } else {
        setIsErrorGuestAmount(true)
      }
    } else {
      setIsErrorChildAmount(false)
      const totalGuest = value + guestAmount

      if (
        singleExperience.typePersons === 0 ||
        totalGuest <= singleExperience.typePersons
      ) {
        setChildAmount(parseInt(value, 10))
        handlePrice(parseInt(value, 10), type)
      } else {
        setIsErrorChildAmount(true)
      }
    }
  }

  const handlePrice = (amount, type) => {
    if (singleExperience.type === 'GROUP') {
      handleGroupPrice(amount, type)
    } else if (singleExperience.type === 'SINGLE') {
      handleSinglePrice(amount, type)
    } else {
      handlePxqPrice(amount, type)
    }
  } // esto no deberia funcionar para hotel y experiencia

  const handlePxqPrice = (amount, type) => {
    let adultPrice = 0,
      childPrice = 0,
      addonTotalPrice = 0
    if (type === 'adult') {
      const addonPriceArray = selectedAddons
        .filter((item) => item.selected && !item.isSpecial)
        .map((item) => item.price)
      const addonAddArray = addArrayItems(addonPriceArray)
      const totalGuest =
        type === 'adult' ? amount + childAmount : amount + guestAmount
      addonTotalPrice = addonAddArray * totalGuest
      setAddonsPrice(addonTotalPrice)

      if (
        singleExperience?.priceQuantity?.length > 0 &&
        singleExperience.type === 'PXQ' &&
        !resultPxq
      ) {
        const pricesQuantity = singleExperience.priceQuantity
        const index = pricesQuantity.findIndex(
          (x) => x.from <= amount && x.to >= amount,
        )

        adultPrice =
          amount *
          pricesQuantity[index !== -1 ? index : pricesQuantity.length - 1].price
      } else {
        adultPrice = amount * singleExperience.valuePerPerson
      }

      childPrice = childAmount * singleExperience.valuePerChild

      setReservationPrice(adultPrice + childPrice)

      setTotalPrice(adultPrice + childPrice + addonTotalPrice)

      if (singleExperience.isPartialCharge) {
        setPartialPrice(
          (adultPrice + childPrice + addonTotalPrice) *
          (singleExperience.partialPercentage / 100),
        )
      }
    } else {
      const addonPriceArray = selectedAddons
        .filter((item) => item.selected && !item.isSpecial)
        .map((item) => item.price)
      const addonAddArray = addArrayItems(addonPriceArray)
      const totalGuest =
        type === 'adult' ? amount + childAmount : amount + guestAmount
      addonTotalPrice = addonAddArray * totalGuest
      setAddonsPrice(addonTotalPrice)

      childPrice = amount * singleExperience.valuePerChild
      adultPrice = guestAmount * singleExperience.valuePerPerson
      setReservationPrice(childPrice + adultPrice)
      setTotalPrice(adultPrice + childPrice + addonTotalPrice)
    }
  }

  const handleGroupPrice = (amount, type) => {
    if (!amount) {
      setReservationPrice(0)
      setTotalPrice(0)
      setAddonsPersonsPrice(0)
      setPartialPrice(0)
    } else {
      let reservationPrice = 0,
        addonTotalPrice = 0
      if (singleExperience.seasons && singleExperience.seasons.length) {
        const season = singleExperience.seasons.filter((season) =>
          checkDateIsBetweenRange(
            formatDateToDB(singleDate),
            season.startDate,
            season.endDate,
          ),
        )

        if (season.length) {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          reservationPrice = season[0].adultPrice
          setReservationPrice(reservationPrice)
          setTotalPrice(reservationPrice + addonTotalPrice)
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          reservationPrice = singleExperience.valuePerPerson
          setReservationPrice(reservationPrice)
          setTotalPrice(reservationPrice + addonTotalPrice)
        }
      } else {
        //Calcular precio de Addons
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        //Calcular precio de la reserva mas Addons
        reservationPrice = singleExperience.valuePerPerson
        setReservationPrice(reservationPrice)
        setTotalPrice(reservationPrice + addonTotalPrice)
      }

      if (singleExperience.isPartialCharge) {
        const calcPartialPrice =
          (reservationPrice + addonTotalPrice) *
          (singleExperience.partialPercentage / 100)

        const rounded = calcPartialPrice.toFixed(2)
        setPartialPrice(rounded)
      }
    }
  }

  const handleSinglePrice = (amount, type) => {
    if (singleExperience.seasons && singleExperience.seasons.length) {
      const checkIfDateIsSeason = singleExperience.seasons.filter((item) =>
        checkDateIsBetweenRange(
          formatDateToDB(singleDate),
          item.startDate,
          item.endDate,
        ),
      )

      if (checkIfDateIsSeason.length) {
        let adultPrice = 0,
          childPrice = 0,
          addonTotalPrice = 0
        if (type === 'adult') {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = amount * checkIfDateIsSeason[0].adultPrice
          childPrice = childAmount * checkIfDateIsSeason[0].childPrice

          setReservationPrice(adultPrice + childPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)

          if (singleExperience.isPartialCharge) {
            setPartialPrice(
              (adultPrice + childPrice + addonTotalPrice) *
              (singleExperience.partialPercentage / 100),
            )
          }
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = guestAmount * checkIfDateIsSeason[0].adultPrice
          childPrice = amount * singleExperience.valuePerChild
          setReservationPrice(childPrice + adultPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)
        }
      } else {
        let adultPrice = 0,
          childPrice = 0,
          addonTotalPrice = 0
        if (type === 'adult') {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = amount * singleExperience.valuePerPerson
          childPrice = childAmount * singleExperience.valuePerChild
          setReservationPrice(adultPrice + childPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)

          if (singleExperience.isPartialCharge) {
            setPartialPrice(
              (adultPrice + childPrice + addonTotalPrice) *
              (singleExperience.partialPercentage / 100),
            )
          }
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          childPrice = amount * singleExperience.valuePerChild
          adultPrice = guestAmount * singleExperience.valuePerPerson
          setReservationPrice(childPrice + adultPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)
        }
      }
    } else {
      let adultPrice = 0,
        childPrice = 0,
        addonTotalPrice = 0
      if (type === 'adult') {
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        if (
          singleExperience?.priceQuantity?.length > 0 &&
          singleExperience.type === 'PXQ' &&
          !resultPxq
        ) {
          const pricesQuantity = singleExperience.priceQuantity
          const index = pricesQuantity.findIndex(
            (x) => x.from <= amount && x.to >= amount,
          )

          adultPrice =
            amount *
            pricesQuantity[index !== -1 ? index : pricesQuantity.length - 1]
              .price
        } else {
          adultPrice = amount * singleExperience.valuePerPerson
        }

        childPrice = childAmount * singleExperience.valuePerChild

        setReservationPrice(adultPrice + childPrice)

        setTotalPrice(adultPrice + childPrice + addonTotalPrice)

        if (singleExperience.isPartialCharge) {
          setPartialPrice(
            (adultPrice + childPrice + addonTotalPrice) *
            (singleExperience.partialPercentage / 100),
          )
        }
      } else {
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        childPrice = amount * singleExperience.valuePerChild
        adultPrice = guestAmount * singleExperience.valuePerPerson
        setReservationPrice(childPrice + adultPrice)
        setTotalPrice(adultPrice + childPrice + addonTotalPrice)
      }
    }
  }

  const getServicesBlockeds = async () => {
    const response = await firebaseDb
      .collection(
        `agency/${agency.key}/experiences/${singleExperience.key}/services`,
      )
      .where('isBlocked', '==', true)
      .get()

    const services = []
    response.forEach((r) => {
      services.push({ id: r.id, ...r.data() })
    })
    setServicesBlockeds(services)
    setIsServicesBlocked(services.length > 0)
  }

  function validPreviousDays() {
    const previousDays = singleExperience.previousDays
    const dateToday = new Date()
    dateToday.setHours(0, 0, 0, 0) // Establece la hora a las 00:00:00 para ignorar las diferencias de hora
    const dateSelected = new Date(selectedDate)
    dateSelected.setHours(0, 0, 0, 0)

    const timeDifference = dateSelected - dateToday // Diferencia en milisegundos
    const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000)) // Diferencia en días

    if (previousDays > daysDifference) {
      setOpenSnackBarMinDays(true)
      return false
    } else if (previousDays <= daysDifference) {
      return true
    }
  }

  function ifGiftCardDate() {
    const date = new Date()
    setSelectedDate(date)
    handleDateAndTime(schedule, date)
    setSingleDate(new Date(date))
    setIsErrorSingleDate(false)
    setReservationPrice(0)
    handleGuestAmount(0, 'adult')
    setChildAmount(0)
    setTotalPrice(0)
    resetSelectedAddons()
    setAddonsPersonsPrice(0)
  }

  function ifGiftCardTime() {
    setTime('12:00AM')
    setIsErrorTime(false)
    setIsServiceBlocked(false)
  }

  const tabClick = (key) => {
    if (key === 'tab1') {
      const dateInitExp = new Date(singleExperience.dateInit)
      const actualDate = new Date()
      if (dateInitExp > actualDate) {
        const date = dateInitExp
        date.setDate(dateInitExp.getDate())
        setSingleDate(date)
        setSelectedDate(date)
      } else if (dateInitExp <= actualDate) {
        const date = new Date()
        if (singleExperience.previousDays) {
          const datePrev = new Date()
          datePrev.setDate(datePrev.getDate() + singleExperience.previousDays)
          setSingleDate(datePrev)
          setSelectedDate(datePrev)
        } else {
          setSingleDate(date)
          setSelectedDate(date)
        }
      }

      handleGuestAmount(0, 'adult')
      setTime('')
      setIsDisableTime(true)
      setIsGiftCard(false)
    } else {
      setIsGiftCard(true)
      ifGiftCardDate()
      ifGiftCardTime()
    }
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const dateFormat = 'MM/DD/YYYY'

  const dataTimeSelect = () => {
    timeSelect?.forEach((t) => treeData.push({ value: t, title: t }));
  }
  dataTimeSelect()


  const allPxqData = [
    {
      key: 'pxqTab',
      label: 'Tabla de precios por cantidad de personas',
      children:
        singleExperience && singleExperience?.priceQuantity
          ? singleExperience.priceQuantity
            .slice() // Hacemos una copia del array para no modificar el original
            .sort((a, b) => a.from - b.from) // Ordenamos de menor a mayor por pxq.from
            .map((pxq, i) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '-3%',
                  }}
                  key={i}
                >
                  <p>
                    De {pxq.from} a {pxq.to} persona(s)
                  </p>
                  <CurrencyFormat
                    value={pxq.price}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </div>
              )
            })
          : null,
    },
  ]

  const items = [
    {
      key: 'tab1',
      label: 'RESERVA',
      children: (
        <div
          className="container-checkout"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            marginTop: '12px',
          }}
        // className="spacer"
        >
          <Row
            gutter={16}
            className="grid-reserva-step1"
            style={{ width: '100% !important' }}
          >
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="datepicker-step1"
            >
              <Form.Item
                label={(() => {
                  if (!singleExperience.minPassengers) {
                    return 'Participantes'
                  } else if (singleExperience.minPassengers > 0) {
                    return `Participantes (${singleExperience.minPassengers} o más)`
                  }
                })()}
                className="itemColon"
                colon={false}
                labelCol={{ span: 24 }}
              >
                <InputNumber
                  defaultValue={0}
                  min={
                    singleExperience.minPassengers >= 1
                      ? singleExperience.minPassengers
                      : 0
                  }
                  disabled={guestIsDisable()}
                  size="middle"
                  onKeyUp={handleKeyPress}
                  status={isErrorGuestAmount ? 'error' : null}
                  required
                  value={guestAmount}
                  onChange={(value) => {
                    if (value === null || value === undefined || value === '') {
                      value = 0
                    }
                    handleGuestAmount(value, 'adult')
                    setSingleDate('')
                    setSelectedDate('')
                    setTime('')
                  }}
                  // onKeyDown={handleKeyDown}
                  className="inputnumber"
                />
              </Form.Item>
            </Col>
            {singleExperience.valuePerChild ? (
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="label-pChild-step1"
              >
                <Form.Item
                  label={(() => {
                    if (!singleExperience.kidsAge) {
                      return 'Niños (hasta 12 años)'
                    } else if (singleExperience.kidsAge === 0) {
                      return 'Niños (hasta 12 años)'
                    } else if (singleExperience.kidsAge > 0) {
                      return `Niños (hasta ${singleExperience.kidsAge} años)`
                    }
                  })()}
                  colon={false}
                  labelCol={{ span: 24 }}
                  className="itemColon"
                >
                  <InputNumber
                    defaultValue={0}
                    min={0}
                    size="middle"
                    disabled={
                      singleExperience.isPartialCharge &&
                        singleExperience.partialPercentage === 0 &&
                        hotDeal
                        ? null
                        : guestIsDisable()
                    }
                    status={isErrorChildAmount ? 'error' : null}
                    value={
                      singleExperience.isPartialCharge &&
                        singleExperience.partialPercentage === 0 &&
                        hotDeal
                        ? hotDeal.childAmount
                        : childAmount
                    }
                    onChange={(value) => {
                      if (
                        value === null ||
                        value === undefined ||
                        value === ''
                      ) {
                        value = 0
                      }
                      handleGuestAmount(value, 'child')
                    }}
                    className="inputnumber"
                  // onKeyDown={handleKeyDown}
                  />
                </Form.Item>
              </Col>
            ) : null}
          </Row>

          {singleExperience.seasons &&
            singleExperience.seasons.map((item) => (
              <>
                <Row
                  gutter={16}
                  style={{ width: '90%', marginTop: '2%', margin: 'auto' }}
                  key={item.name}
                >
                  <Col xs={24}>
                    <AntdAlert
                      message={
                        <>
                          <Row gutter={16}>
                            <Col xs={12}>
                              <p style={{ margin: 0 }}>
                                Temporada: {item.name}
                              </p>
                              <p style={{ margin: 0 }}>
                                Precio:
                                <CurrencyFormat
                                  value={item.adultPrice}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                              </p>
                            </Col>
                            <Col xs={12} style={{ textAlign: 'right' }}>
                              <p style={{ margin: 0 }}>
                                Comienzo:
                                {formatDBDate(item.startDate)}
                              </p>
                              <p style={{ margin: 0 }}>
                                Final:
                                {formatDBDate(item.endDate)}
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                      type="info"
                      showIcon
                    />
                  </Col>
                </Row>
              </>
            ))}
          {isExperiencesEnded && (
            <Snackbar
              open={openSnackBar}
              autoHideDuration={6000}
              onClose={() => setOpenSnackBar(false)}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert onClose={() => setOpenSnackBar(false)} severity="info">
                Esta experiencia ha culminado
              </Alert>
            </Snackbar>
          )}
          {isAvailableCapacity && (
            <Snackbar
              open={openSnackBarCapacity}
              autoHideDuration={6000}
              onClose={() => {
                setIsAvailableCapacity(false)
                setOpenSnackBarCapacity(false)
              }}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              {singleExperience.type === 'GROUP' ? (
                <Alert
                  onClose={() => {
                    setIsAvailableCapacity(false)
                    setOpenSnackBarCapacity(false)
                  }}
                  severity="error"
                >
                  El día y hora seleccionados no poseen capacidad
                </Alert>
              ) : (
                <Alert
                  onClose={() => {
                    setIsAvailableCapacity(false)
                    setOpenSnackBarCapacity(false)
                  }}
                  severity="error"
                >
                  La disponibilidad en el día y hora seleccionados, es menor a
                  la cantidad de participantes
                </Alert>
              )}
            </Snackbar>
          )}

          {
            <Row
              gutter={16}
              className="grid-reserva-step1"
              style={{ width: '100% !important' }}
            >
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="datepicker-step1"
              >
                <Form.Item
                  label="Fecha"
                  labelCol={{ span: 24 }}
                  className="itemColon"
                  colon={false}
                >
                  <DatePicker
                    className="picker"
                    format={dateFormat}
                    timeZone="GMT-3"
                    disabled={
                      singleExperience.isPartialCharge &&
                        singleExperience.partialPercentage === 0 &&
                        hotDeal
                        ? null
                        : isExperiencesEnded || guestAmount === 0
                          ? true
                          : false
                    }
                    status={
                      isErrorSingleDate && isPreviousDaysOk ? 'error' : null
                    }
                    placeholder="Seleccione un día"
                    size="middle"
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(date) => {
                      specificDatesTimeSelect(date ? date.toDate() : null)
                      setSelectedDate(date ? date.toDate() : null)
                      handleDateAndTime(schedule, date ? date.toDate() : null)
                      setSingleDate(date ? date.toDate() : null)
                      setIsErrorSingleDate(false)
                      setTime()
                      // setReservationPrice(0)
                      // setGuestAmount(0)
                      // setChildAmount(0)
                      // setTotalPrice(0)
                      // resetSelectedAddons()
                      // setAddonsPersonsPrice(0)
                      setDay(date ? date.toDate() : null)
                    }}
                    onKeyUp={handleKeyPress}
                    allowClear={{ clearIcon: null }}
                    onOpenChange={handleOpenChange}
                    onPanelChange={handlePanelChange}
                    disabledDate={(date) => {
                      const currentDate = dayjs()
                      const minDate = handleMinDate()
                      const maxDate = handleMaxDate()
                      const dateString = date.format('YYYY-MM-DD')
                      // matchingAviabilitiesPerDate()
                      // resultsArray.forEach((isAvailable, index) => {
                      //   if (isAvailable) {
                      //     return false
                      //     // Realizar acciones específicas cuando la fecha está disponible
                      //   } else {
                      //     return true
                      //     // Realizar acciones específicas cuando la fecha no está disponible
                      //   }
                      // })

                      if (minDate && date < minDate) {
                        return true
                      }

                      if (maxDate && date > maxDate) {
                        return true
                      }

                      // if (prevDays.includes(dateString)) {
                      //   return true
                      // }

                      return filterDates(date)
                    }}
                  />
                </Form.Item>
              </Col>
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="label-hr-r-step1"
              >
                <Form.Item
                  label="Horario"
                  labelCol={{ span: 24 }}
                  className="itemColon"
                  colon={false}
                >
                  <TreeSelect
                    className="picker"
                    style={{ width: '100% !important' }}
                    placeholder="Seleccione un horario"
                    onKeyUp={handleKeyPress}
                    status={!isDisableTime && isErrorTime ? 'error' : null}
                    id="select-time"
                    size="middle"
                    value={time}
                    treeData={treeData}
                    onChange={(value) => {
                      setTime(value)
                      setIsErrorTime(false)
                      validateServiceHour(value)
                      setIsServiceBlocked(false)
                      selectMaxPassengers(value)
                    }}
                    treeDefaultExpandAll
                    disabled={
                      singleExperience.isPartialCharge &&
                        singleExperience.partialPercentage === 0 &&
                        hotDeal
                        ? null
                        : isDisableTime
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          }
          {isServiceBlocked && (
            <Grid item xs={12}>
              <Alert severity="error" className="alertBlock">
                El servicio se encuentra bloqueado para esta fecha, por favor
                selecciona otra
              </Alert>
            </Grid>
          )}

          {singleExperience.isPartialCharge &&
            singleExperience.partialPercentage !== 0 ? (
            <Grid item xs={12}>
              <Alert severity="warning" icon={false}>
                Tipo de pago parcial (Inicial{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {singleExperience.partialPercentage}% -{' '}
                  {100 - singleExperience.partialPercentage}%
                </span>{' '}
                Restante )
              </Alert>
            </Grid>
          ) : hotDeal &&
            singleExperience.isPartialCharge &&
            singleExperience.partialPercentage ===
            0 ? null : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 ? (
            <Grid item xs={12}>
              <Alert severity="warning" icon={false}>
                Con esta pre reserva se espera una confirmación del proveedor
                para realizar el pago
              </Alert>
            </Grid>
          ) : null}

          {singleExperience.type === 'PXQ' &&
            !resultPxq &&
            !!singleExperience?.priceQuantity && (
              <Row
                gutter={16}
                style={{ width: '90%', margin: 'auto', marginTop: '2%' }}
              >
                <Col span={24}>
                  <Collapse
                    size="small"
                    items={allPxqData}
                    expandIconPosition="end"
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            )}

          <Row gutter={16} style={{ width: '100%', padding: '4%' }}>
            {selectedAddons && selectedAddons.length > 0 ? (
              <Col span={24} style={{ width: '100%' }}>
                <p
                  style={{ margin: 0, fontWeight: 'bold' }}
                  className={classes.fontQuicksand}
                >
                  Servicios Adicionales
                </p>
                {selectedAddons.map((addon, index) => (
                  <Row
                    gutter={16}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      margin: '0',
                    }}
                    key={addon.key}
                    className={classes.fontMuli}
                  >
                    <Col
                      span={12} // Controla la mitad izquierda del espacio disponible
                      style={{
                        display: 'flex',
                        margin: '0',
                        alignItems: 'center',
                      }}
                    >
                      <Checkbox
                        checked={addon.selected}
                        onChange={(e) =>
                          addon.isSpecial
                            ? handleAddonsSpecial(
                              e.target.checked,
                              addon,
                              index,
                            )
                            : handleAddons(e.target.checked, addon, index)
                        }
                      />
                      <small
                        style={{
                          textTransform: 'capitalize',
                          marginLeft: '1%',
                        }}
                      >
                        {addon.name}
                      </small>
                    </Col>
                    <Col
                      span={12} // Controla la mitad derecha del espacio disponible
                      style={{
                        display: 'flex',
                        margin: '0',
                        alignItems: 'center',
                        justifyContent: 'flex-end', // Alinea el contenido a la derecha
                      }}
                    >
                      {addon.isSpecial && (
                        <div
                          style={{
                            width: '100%',

                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <InputNumber
                            disabled={!addon.selected}
                            defaultValue={1}
                            style={{
                              marginLeft: '5px',
                              width: '50px',
                              height: '30px',
                              justifyContent: 'center',
                            }}
                            // value={!!addon.quantity ? addon.quantity : 0}
                            min={1}
                            onChange={(value) =>
                              handleChangeQty(parseInt(value), addon, index)
                            }
                          />
                          <small>
                            <CurrencyFormat
                              value={addon.price}
                              displayType="text"
                              thousandSeparator
                              prefix="$"
                            />
                            {addon.isSpecial && '/un'}
                          </small>
                        </div>
                      )}

                      {!addon.isSpecial && (
                        <>
                          <small>
                            <CurrencyFormat
                              value={addon.price}
                              displayType="text"
                              thousandSeparator
                              prefix="$"
                            />
                          </small>
                        </>
                      )}
                    </Col>
                  </Row>
                ))}
              </Col>
            ) : null}

            <Row gutter={16} style={{ width: '100%' }}>
              <hr className="hr-style" />

              {singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 &&
                !hotDeal ? null : (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Precio por Persona{' '}
                  <CurrencyFormat
                    value={
                      singleExperience.seasons &&
                        singleExperience.seasons.length >= 1
                        ? singleExperience.seasons[0].adultPrice
                        : singleExperience.valuePerPerson
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              )}
              {singleExperience.valuePerChild ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Precio por niños{' '}
                  <CurrencyFormat
                    value={singleExperience.valuePerChild}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {selectedAddons && selectedAddons.length > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Adicionales{' '}
                  <CurrencyFormat
                    value={addonsPrice ? addonsPrice : 0}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {selectedAddons && selectedAddons.length > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    marginLeft: '2%',

                    width: '100%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Adicionales por persona{' '}
                  <CurrencyFormat
                    value={addonsPersonsPrice}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              <hr className="hr-style" />
              {singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? null : (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    marginLeft: '2%',

                    width: '100%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Reserva{' '}
                  <CurrencyFormat
                    value={
                      !!reservationPrice
                        ? reservationPrice + addonsPrice + addonsPersonsPrice
                        : 0
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              )}
            </Row>

            {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 &&
              hotDeal ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Usted realizará el pago de su pre-reserva">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span style={{}}>{`Pago diferido`}</span>
              </p>
            ) : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Usted realizará una pre-reserva, cuando el proveedor confirme la misma, se le avisará para que efectúe el pago correspondiente">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span style={{}}>{`Pago diferido`}</span>
              </p>
            ) : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage !== 0 ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Es la primera parte del cobro al realizar una reserva, el porcentaje restante será cobrado una vez se haga check-in el dia de la reserva">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span
                  style={{ marginRight: '5px', marginLeft: '5px' }}
                >{`Pago Parcial Inicial (${singleExperience.partialPercentage}%): `}</span>

                <CurrencyFormat
                  value={
                    ((!!reservationPrice
                      ? reservationPrice + addonsPrice + addonsPersonsPrice
                      : 0) *
                      singleExperience.partialPercentage) /
                    100
                  }
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />
              </p>
            ) : null}
          </Row>

          <Space
            style={{ width: '100%', marginTop: '2%', justifyContent: 'center' }}
          >
            <Button
              disabled={isExperiencesEnded}
              variant="contained"
              onClick={validateForm}
              className="btn"
            >
              Continuar
            </Button>
          </Space>
        </div>
      ),
    },
    (singleExperience.isPartialCharge &&
      singleExperience.partialPercentage === 0) ||
      singleExperience.giftCardIsActive === false
      ? null
      : {
        key: 'tab2',
        label: 'GIFT CARD',
        children: (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              boxSizing: 'border-box',
            }}
            className="spacer"
          >
            {timedBlockersAlert}
            {giftCard && (
              <Row gutter={16} style={{ width: '100%', marginTop: '2%' }}>
                <Col xs={24}>
                  <AntdAlert
                    message=" La cantidad máxima de participantes para la compra de una Gift
              Card es de 2 personas!"
                    type="info"
                    showIcon
                  />
                </Col>
              </Row>
            )}

            {isPreviousDaysOk && (
              <Row gutter={16} style={{ width: '90%', marginTop: '2%' }}>
                <Col xs={24}>
                  <AntdAlert
                    message={`Esta experiencia necesita reservarse con ${singleExperience.previousDays} de anticipación`}
                    type="info"
                    showIcon
                  />
                </Col>
              </Row>
            )}
            {singleExperience.seasons &&
              singleExperience.seasons.map((item) => (
                <>
                  <Row
                    gutter={16}
                    style={{ width: '90%', marginTop: '2%' }}
                    key={item.name}
                  >
                    <Col xs={24}>
                      <AntdAlert
                        message={
                          <>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <p style={{ margin: 0 }}>
                                  Temporada: {item.name}
                                </p>
                                <p style={{ margin: 0 }}>
                                  Precio:
                                  <CurrencyFormat
                                    value={item.adultPrice}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                  />
                                </p>
                              </Col>
                              <Col xs={12} style={{ textAlign: 'right' }}>
                                <p style={{ margin: 0 }}>
                                  Comienzo:
                                  {formatDBDate(item.startDate)}
                                </p>
                                <p style={{ margin: 0 }}>
                                  Final:
                                  {formatDBDate(item.endDate)}
                                </p>
                              </Col>
                            </Row>
                          </>
                        }
                        type="info"
                        showIcon
                      />
                    </Col>
                  </Row>
                </>
              ))}
            {isExperiencesEnded && (
              <Snackbar
                open={openSnackBar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackBar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert onClose={() => setOpenSnackBar(false)} severity="info">
                  Esta experiencia ha culminado
                </Alert>
              </Snackbar>
            )}
            {isPassengersCapacity && (
              <Snackbar
                open={openSnackPassengers}
                autoHideDuration={6000}
                onClose={() => setOpenSnackPassengers(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert
                  onClose={() => setOpenSnackPassengers(false)}
                  severity="info"
                >
                  La cantidad máxima de pasajeros es {maxPassengers}
                  {/* No hay capacidad suficiente para los participantes que estás
                seleccionando */}
                </Alert>
              </Snackbar>
            )}
            {isAvailableCapacity && (
              <Snackbar
                open={openSnackBarCapacity}
                autoHideDuration={6000}
                onClose={() => setOpenSnackBarCapacity(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                {singleExperience.type === 'GROUP' ? (
                  <Alert
                    onClose={() => {
                      setIsAvailableCapacity(false)
                      setOpenSnackBarCapacity(false)
                    }}
                    severity="error"
                  >
                    El día y hora seleccionados no poseen capacidad
                  </Alert>
                ) : (
                  <Alert
                    onClose={() => {
                      setIsAvailableCapacity(false)
                      setOpenSnackBarCapacity(false)
                    }}
                    severity="error"
                  >
                    La disponibilidad en el día y hora seleccionados, es menor
                    a la cantidad de participantes
                  </Alert>
                )}
              </Snackbar>
            )}

            <Row
              gutter={16}
              className="grid-gift-step"
              style={{ width: '100% !important' }}
            >
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="participantesGift"
              >
                <Form.Item
                  label=" Participantes"
                  colon={false}
                  labelCol={{ span: 24 }}
                  className="itemColon"
                >
                  <InputNumber
                    defaultValue={0}
                    min={0}
                    max={2}
                    style={{ margin: 'auto', width: '100%' }}
                    disabled={guestIsDisable()}
                    onKeyUp={handleKeyPress}
                    status={isErrorGuestAmount ? 'error' : null}
                    required
                    value={guestAmount}
                    onChange={(value) => {
                      // Verifica si value es un número válido, si no, establece 0
                      if (
                        value === null ||
                        value === undefined ||
                        value === ''
                      ) {
                        value = 0
                      }
                      handleGuestAmount(value, 'adult')
                    }}
                    className="inputnumber"
                  />
                </Form.Item>
              </Col>
              {singleExperience.valuePerChild ? (
                <Col
                  span={window.innerWidth >= 992 ? 8 : 24}
                  className="label-pChild-gift"
                >
                  <Form.Item
                    label={(() => {
                      if (!singleExperience.kidsAge) {
                        return 'Niños (hasta 12 años)'
                      } else if (singleExperience.kidsAge === 0) {
                        return 'Niños (hasta 12 años)'
                      } else if (singleExperience.kidsAge > 0) {
                        return `Niños (hasta ${singleExperience.kidsAge} años)`
                      }
                    })()}
                    colon={false}
                    labelCol={{ span: 24 }}
                    className="itemColon"
                  >
                    <InputNumber
                      min={0}
                      defaultValue={0}
                      style={{ width: '100%' }}
                      disabled={guestIsDisable()}
                      value={childAmount}
                      onChange={(value) => {
                        if (
                          value === null ||
                          value === undefined ||
                          value === ''
                        ) {
                          value = 0
                        }
                        handleGuestAmount(value, 'child')
                      }}
                      className="inputnumber"
                    />
                  </Form.Item>
                </Col>
              ) : null}
            </Row>

            {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage !== 0 ? (
              <Grid item xs={12}>
                <Alert severity="warning" icon={false}>
                  Tipo de pago parcial (Inicial{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {singleExperience.partialPercentage}% -{' '}
                    {100 - singleExperience.partialPercentage}%
                  </span>{' '}
                  Restante )
                </Alert>
              </Grid>
            ) : hotDeal &&
              singleExperience.isPartialCharge &&
              singleExperience.partialPercentage ===
              0 ? null : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? (
              <Grid item xs={12}>
                <Alert severity="warning" icon={false}>
                  Con esta pre reserva se espera una confirmación del
                  proveedor para realizar el pago
                </Alert>
              </Grid>
            ) : null}

            {singleExperience.type === 'PXQ' &&
              !resultPxq &&
              !!singleExperience?.priceQuantity && (
                <Row gutter={16} style={{ width: '100%' }}>
                  <Col span={24}>
                    <Collapse
                      size="small"
                      items={allPxqData}
                      expandIconPosition="end"
                      style={{ width: '100%' }}
                    />
                  </Col>
                </Row>
              )}

            <Row gutter={16} style={{ width: '100%', padding: '4%' }}>
              {selectedAddons && selectedAddons.length > 0 ? (
                <Col span={24} style={{ width: '100%' }}>
                  <p
                    style={{ margin: 0, fontWeight: 'bold' }}
                    className={classes.fontQuicksand}
                  >
                    Servicios Adicionales
                  </p>
                  {selectedAddons.map((addon, index) => (
                    <Row
                      gutter={16}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        margin: '0',
                      }}
                      key={addon.key}
                      className={classes.fontMuli}
                    >
                      <Col
                        span={12} // Controla la mitad izquierda del espacio disponible
                        style={{
                          display: 'flex',
                          margin: '0',
                          alignItems: 'center',
                        }}
                      >
                        <Checkbox
                          checked={addon.selected}
                          onChange={(e) =>
                            addon.isSpecial
                              ? handleAddonsSpecial(
                                e.target.checked,
                                addon,
                                index,
                              )
                              : handleAddons(e.target.checked, addon, index)
                          }
                        />
                        <small
                          style={{
                            textTransform: 'capitalize',
                            marginLeft: '1%',
                          }}
                        >
                          {addon.name}
                        </small>
                      </Col>
                      <Col
                        span={12} // Controla la mitad derecha del espacio disponible
                        style={{
                          display: 'flex',
                          margin: '0',
                          alignItems: 'center',
                          justifyContent: 'flex-end', // Alinea el contenido a la derecha
                        }}
                      >
                        {addon.isSpecial && (
                          <div
                            style={{
                              width: '100%',

                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <InputNumber
                              disabled={!addon.selected}
                              defaultValue={1}
                              style={{
                                marginRight: '10px',
                                width: '50px',
                                height: '30px',
                                justifyContent: 'center',
                              }}
                              // value={!!addon.quantity ? addon.quantity : 0}
                              min={1}
                              onChange={(value) =>
                                handleChangeQty(parseInt(value), addon, index)
                              }
                            />
                            <small>
                              <CurrencyFormat
                                value={addon.price}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                              />
                              {addon.isSpecial && '/un'}
                            </small>
                          </div>
                        )}

                        {!addon.isSpecial && (
                          <>
                            <small>
                              <CurrencyFormat
                                value={addon.price}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                              />
                            </small>
                          </>
                        )}
                      </Col>
                    </Row>
                  ))}
                </Col>
              ) : null}

              <Row gutter={16} style={{ width: '100%' }}>
                <hr className="hr-style" />

                {singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage === 0 ? null : (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      width: '100%',
                      marginLeft: '2%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Precio por Persona{' '}
                    <CurrencyFormat
                      value={
                        singleExperience.seasons &&
                          singleExperience.seasons.length >= 1
                          ? singleExperience.seasons[0].adultPrice
                          : singleExperience.valuePerPerson
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                )}
                {singleExperience.valuePerChild ? (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      width: '100%',
                      marginLeft: '2%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Precio por niños{' '}
                    <CurrencyFormat
                      value={singleExperience.valuePerChild}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                ) : null}

                {selectedAddons && selectedAddons.length > 0 ? (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      width: '100%',
                      marginLeft: '2%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Adicionales{' '}
                    <CurrencyFormat
                      value={addonsPrice ? addonsPrice : 0}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                ) : null}

                {selectedAddons && selectedAddons.length > 0 ? (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      marginLeft: '2%',

                      width: '100%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Adicionales por persona{' '}
                    <CurrencyFormat
                      value={addonsPersonsPrice}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                ) : null}

                <hr className="hr-style" />
                {singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage === 0 ? null : (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      marginLeft: '2%',

                      width: '100%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Reserva{' '}
                    <CurrencyFormat
                      value={
                        !!reservationPrice
                          ? reservationPrice +
                          addonsPrice +
                          addonsPersonsPrice
                          : 0
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                )}
              </Row>

              {singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 &&
                hotDeal ? (
                <p
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    margin: 'auto',
                  }}
                >
                  <Tooltip title="Usted realizará el pago de su pre-reserva">
                    <InfoIcon style={{ fontSize: '20px' }} />
                  </Tooltip>
                  <span style={{}}>{`Pago diferido`}</span>
                </p>
              ) : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? (
                <p
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    margin: 'auto',
                  }}
                >
                  <Tooltip title="Usted realizará una pre-reserva, cuando el proveedor confirme la misma, se le avisará para que efectúe el pago correspondiente">
                    <InfoIcon style={{ fontSize: '20px' }} />
                  </Tooltip>
                  <span style={{}}>{`Pago diferido`}</span>
                </p>
              ) : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage !== 0 ? (
                <p
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignContent: 'center',
                    margin: 'auto',
                  }}
                >
                  <Tooltip title="Es la primera parte del cobro al realizar una reserva, el porcentaje restante será cobrado una vez se haga check-in el dia de la reserva">
                    <InfoIcon style={{ fontSize: '20px' }} />
                  </Tooltip>
                  <span
                    style={{ marginRight: '5px', marginLeft: '5px' }}
                  >{`Pago Parcial Inicial (${singleExperience.partialPercentage}%): `}</span>

                  <CurrencyFormat
                    value={
                      ((!!reservationPrice
                        ? reservationPrice + addonsPrice + addonsPersonsPrice
                        : 0) *
                        singleExperience.partialPercentage) /
                      100
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </p>
              ) : null}
            </Row>

            <Space
              style={{
                width: '100%',
                marginTop: '2%',
                justifyContent: 'center',
              }}
            >
              <Button
                style={{ margin: 'auto' }}
                disabled={isExperiencesEnded}
                variant="contained"
                onClick={validateForm}
                className="btn"
              >
                Continuar
              </Button>
            </Space>
          </div>
        ),
      },
  ]

  return (
    <Layout style={{ width: '100%' }}>
      <Space>
        <Tabs
          defaultActiveKey="activeKey"
          items={items}
          onChange={handleChange}
          onTabClick={tabClick}
          tabBarStyle={{ textAlign: 'center' }}
        ></Tabs>
      </Space>
    </Layout>
  )
}

export default ReservationDetailsAgency
